import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import './ExternalUserScreen.css'
import ContactInfoRendering from '../utils/ContactInfoRendering';
import PaymentsDeeplinkGenerator from '../utils/PaymentsDeeplinkGenerator';
import SocialDeeplinkGenerator from '../utils/SocialDeeplinkGenerator';
import PaidIcon from '../icons/Payments_tt.png';
import ContactsIcon from '../icons/Contact_tt.png';
import ShareIcon from '../icons/Social_tt.png';

function areAllValuesNull(obj) {
  return Object.values(obj).every(method => method.showInput === false);
}

// Tabs Component
const TabsComponent = ({ selectedContactInfo, selectedPayments, selectedSocialMedia, selectedProducts }) => {
  const getInitialTab = () => {
    if (selectedProducts && selectedProducts.length > 0) {
      if (selectedProducts.includes('Payments')) return 'Payments';
      if (selectedProducts.includes('Contact Info')) return 'Contact Info';
      if (selectedProducts.includes('Social')) return 'Social Links';
    }
    // Fallback to the old logic if no selectedProducts
    return !areAllValuesNull(selectedPayments) ? 'Payments' : 
           (!areAllValuesNull(selectedContactInfo) ? 'Contact Info' : 'Social Links');
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  const renderPaymentsTab = () => {
    return (
      <div className="payment-options">
        {Object.keys(selectedPayments).map((option) => (
          selectedPayments[option].showInput ? (
            <div key={selectedPayments[option].id} className="payment-link">
              <PaymentsDeeplinkGenerator
                type={selectedPayments[option].id}
                id={selectedPayments[option].value}
                name={selectedPayments[option].name}
              />
            </div>
          ) : (
            <React.Fragment key={option} />
          )
        ))}
      </div>
    );
  };
  

  const renderSocialMediaTab = () => {
    return (
      <div className="social-media-grid">
        {Object.keys(selectedSocialMedia).map((option) => (
          selectedSocialMedia[option].showInput ? (
            <div key={selectedSocialMedia[option].id} className="social-media-item">
              <SocialDeeplinkGenerator
                type={selectedSocialMedia[option].id}
                id={selectedSocialMedia[option].value}
                name={selectedSocialMedia[option].name}
              />
            </div>
          ) : (
            <React.Fragment key={option} />
          )
        ))}
      </div>
    );
  };

  const showPayments = !selectedProducts || !selectedProducts.includes('Payments');
  const showContact = !selectedProducts || !selectedProducts.includes('Contact Info');
  const showSocial = !selectedProducts || !selectedProducts.includes('Social');
  console.log(showPayments, showContact, showSocial);

  return (
    <div className="tabs-container">
      {showPayments + showContact + showSocial > 1 ? <></> : 
      <div className="tabs">
        {showPayments ? <></> : 
          <button 
            className={activeTab === 'Payments' ? 'active' : ''} 
            onClick={() => setActiveTab('Payments')}
            title="Payments"
          >
            <img src={PaidIcon} alt="Payments" />
          </button>
        }
        {showContact ? <></> : 
          <button 
            className={activeTab === 'Contact Info' ? 'active' : ''} 
            onClick={() => setActiveTab('Contact Info')}
            title="Contact Info"
          >
            <img src={ContactsIcon} alt="Contact Info" />
          </button>
        }
        {showSocial ? <></> : 
          <button 
            className={activeTab === 'Social Links' ? 'active' : ''} 
            onClick={() => setActiveTab('Social Links')}
            title="Social Links"
          >
            <img src={ShareIcon} alt="Social Links" />
          </button>
        }
      </div>}

      <div className={showPayments + showContact + showSocial > 1? "no-tab-content" : "tab-content"}>
        {activeTab === 'Payments' && renderPaymentsTab()}
        {activeTab === 'Contact Info' && <ContactInfoRendering
          firstName={selectedContactInfo['FIRST_NAME'] || ''}
          lastName={selectedContactInfo['LAST_NAME'] || ''}
          email={selectedContactInfo['EMAIL'] || ''}
          phone={selectedContactInfo['PHONE'] || ''}
          address={selectedContactInfo['ADDRESS'] || ''}
        />}
        {activeTab === 'Social Links' && renderSocialMediaTab()}
      </div>
    </div>
  );
};

const ExternalUserScreen = ({ selectedPayments, selectedContactInfo, selectedSocialMedia, userDisplay, actual_uuid, selectedProducts }) => {
  const { uuid } = useParams();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('user_id') || '1';
  const imageUrl = `https://cdn.eztiptap.com/user_photos/${actual_uuid}/user_${userId}.png`;
  const [imageExists, setImageExists] = useState(false);

  useEffect(() => {
    const checkImage = async () => {
      try {
        const response = await fetch(imageUrl);
        setImageExists(response.ok);
      } catch (error) {
        setImageExists(false);
      }
    };
    checkImage();
  }, [imageUrl]);

  const getInitial = () => {
    if (!userDisplay) return '?';
    return userDisplay.charAt(0).toUpperCase();
  };

  return (
    <div className="external-user-screen">
      <div className="profile-section">
        <div className="profile-image-container">
          {imageExists ? (
            <img 
              src={imageUrl} 
              alt="Profile" 
              className="profile-image"
            />
          ) : (
            <div className="profile-letter-avatar">
              {getInitial()}
            </div>
          )}
        </div>
        {userDisplay && (
          <div className="profile-name">
            {userDisplay}
          </div>
        )}
      </div>
      <TabsComponent 
        selectedContactInfo={selectedContactInfo} 
        selectedSocialMedia={selectedSocialMedia} 
        selectedPayments={selectedPayments}
        selectedProducts={selectedProducts}
      />
    </div>
  );
};

export default ExternalUserScreen;
